import { useState } from "react";
import { useT } from "@/i18n";
import SpeakButton from "@/components/SpeakButton";
import { STORY_TEXT } from "@/components/story/content";
import StoryWizard from "@/components/story/StoryWizard";
import ScriptEditor from "@/components/story/ScriptEditor";
import Teleprompter from "@/components/story/Teleprompter";

export default function StoryStudio() {
  const { lang } = useT();
  const tx = STORY_TEXT[lang];
  const [script, setScript] = useState(null);
  const [cover, setCover] = useState(null);
  const [view, setView] = useState("wizard");

  const onScript = (s) => { setScript(s); setCover(null); setView("script"); };
  const restart = () => { setScript(null); setCover(null); setView("wizard"); };

  return (
    <section className="learn-bg rounded-[2rem] border-4 border-white shadow-xl p-5 sm:p-8 mt-8 space-y-8" data-testid="story-studio">
      <div>
        <div className="text-center">
          <h2 className="inline-block bg-yellow-300 border-4 border-white rounded-[2rem] px-6 sm:px-10 py-2 sm:py-3 shadow-xl font-fredoka text-2xl sm:text-4xl lg:text-5xl font-bold text-blue-900 uppercase -rotate-1" data-testid="story-title">{tx.title}</h2>
        </div>
        <div className="mt-6 rounded-[2rem] overflow-hidden border-4 border-white shadow-xl">
          <img src="/img/story-scene.webp" alt="Lumi y Spark con un teleprompter" className="w-full h-auto block" data-testid="story-scene-img" />
        </div>
        <div className="mt-5 text-center">
          <span className="inline-block bg-yellow-300 border-4 border-white rounded-full px-8 py-2 font-fredoka text-xl sm:text-3xl font-bold text-blue-900 shadow-lg" data-testid="story-motto">{tx.motto}</span>
        </div>
        <div className="mt-5 bg-white/90 rounded-3xl px-5 py-3 font-bold text-blue-900 shadow-md flex flex-wrap items-center gap-3">
          <span className="flex-1 min-w-[12rem]">{tx.intro}</span>
          <SpeakButton key={`intro-${lang}`} mascot="lumi" text={tx.intro} testId="story-intro-speak" compact />
        </div>
      </div>
      {view === "wizard" && <StoryWizard onScript={onScript} />}
      {view === "script" && script && (
        <ScriptEditor script={script} setScript={setScript} cover={cover} setCover={setCover} onRead={() => setView("prompter")} onRestart={restart} />
      )}
      {view === "prompter" && script && <Teleprompter script={script} cover={cover} onBack={() => setView("script")} />}
    </section>
  );
}
